
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ResultInviterUtilisateursModel } from 'src/models/pilotage/resultInviterUtilisateursModel';

@Component({
    selector: 'app-utilisateurs-deja-enregistres-dialog',
    templateUrl: './utilisateurs-deja-enregistres-dialog.component.html',
    styleUrls: ['./utilisateurs-deja-enregistres-dialog.component.scss'],
    imports: [MatDialogModule, TranslateModule]
})
export class UtilisateursDejaEnregistresDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<UtilisateursDejaEnregistresDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResultInviterUtilisateursModel
  ) { }

  ngOnInit(): void {
  }

}
